import client from "./client";

export const recordEvents = ({ events }) =>
  client.post("analytics/events", { events });
